import { ReactNode } from 'react'
import styled from 'styled-components'

import { media } from 'styles/media'

import SimpleAnchor from '../../../components/display/SimpleAnchor'
import FeesIcon from '../../../components/icons/Fees'
import FulfillmentIcon from '../../../components/icons/Fulfillment'
import CommunityMindedIcon from '../../../components/icons/CommunityMinded'
import StoriesIllustrationIcon from '../../../components/icons/StoriesIllustration'
import {
  SpacedColumn,
  ResponsiveTwoColumnLayout,
} from '../../../components/landing/display'
import { Inner as InfoParagraphInner } from '../../../components/landing/InfoParagraph'

const IllustrationWrapper = styled.div`
  svg {
    width: 130px;
    height: 90px;
  }

  margin-bottom: 20px;
`

export const HighlightedSpan = styled.span`
  color: ${({ theme }) => theme['-ds-core-400'].value};
  font-weight: 400;
`

const Heading = styled.h4`
  font-weight: 300;
  color: ${({ theme }) => theme['-ds-core-300'].value};
  line-height: 1.5;

  font-size: 16px;
  ${media.md`
    font-size: 24px;
  `}
`

const GridCell = styled.div`
  ${media.md`
    align-self: stretch;
    height: 400px;
  `}

  display: flex;
  justify-content: center;
`

type IllustratedInfoProps = {
  heading: ReactNode
  illustration: ReactNode
}

const IllustratedInfo = ({ heading, illustration }: IllustratedInfoProps) => {
  return (
    <GridCell>
      <InfoParagraphInner>
        <IllustrationWrapper>{illustration}</IllustrationWrapper>
        <Heading>{heading}</Heading>
      </InfoParagraphInner>
    </GridCell>
  )
}

const GridColumn = styled(SpacedColumn)`
  align-items: flex-start;
  ${media.md`
    &:not(:last-child) {
      border-right: 1px solid ${({ theme }) => theme['-ds-neutral-300'].value};
    }

    ${GridCell} {
      &:not(:last-child) {
        border-bottom: 1px solid ${({ theme }) =>
          theme['-ds-neutral-300'].value};
      }
      margin: 0;
      padding: 30px;
    }
  `}
`

const WhyBecomeAHost = () => {
  return (
    <ResponsiveTwoColumnLayout columnMarginBottom={40}>
      <GridColumn>
        <IllustratedInfo
          heading={
            <>
              <HighlightedSpan>Riparide Stories.</HighlightedSpan> Our Stories
              bring properties to life and have been proven to drive more
              bookings.{' '}
              <SimpleAnchor href="/stories-hosts">Learn more</SimpleAnchor>
            </>
          }
          illustration={<StoriesIllustrationIcon />}
        />
        <IllustratedInfo
          heading={
            <>
              <HighlightedSpan>
                We attract customers you’ll love to host!
              </HighlightedSpan>{' '}
              Most of our customers are couples who want to connect with nature
              and relax.
            </>
          }
          illustration={<CommunityMindedIcon />}
        />
      </GridColumn>
      <GridColumn>
        <IllustratedInfo
          heading={
            <>
              <HighlightedSpan>Low fees.</HighlightedSpan> We keep our fees
              lower than most, which means more money in your pocket.
            </>
          }
          illustration={<FeesIcon />}
        />
        <IllustratedInfo
          heading={
            <>
              <HighlightedSpan>Deliver fulfillment.</HighlightedSpan> We&apos;re
              all about inspiring people to get out of the city and chase
              fulfilling moments in nature.
              <br />
              <br />
            </>
          }
          illustration={<FulfillmentIcon />}
        />
      </GridColumn>
    </ResponsiveTwoColumnLayout>
  )
}

export default WhyBecomeAHost
